/**
 * 分岐レイヤーが共有する小さな判定（Issue #589）。**ここは ocg の語彙を知ってよい**（`editorPorts/`）が、
 * 演出（テーマ）はここを import しない —— 結果は payload に載って届く。
 */
import { parseZoneKey } from '../../duelEditor/core/field/zones';

/** 場（モンスター・魔法罠・フィールド魔法）のゾーンの種類 */
export const FIELD_KINDS = Object.freeze(['monster', 'magic_trap', 'field']);
/** 山・手札（場を経由しない移動の出どころ・行き先） */
export const PILE_KINDS = Object.freeze(['grave', 'removed', 'hand', 'maindeck', 'extra']);

export const kindOf = (zone) => parseZoneKey(zone)?.kind ?? null;
export const isFieldZone = (zone) => FIELD_KINDS.includes(kindOf(zone));
export const isMonsterZone = (zone) => kindOf(zone) === 'monster';
/** 魔法・罠ゾーン（フィールド魔法も）。表示形式は表裏だけで向きは無い */
export const isSpellZone = (zone) => kindOf(zone) === 'magic_trap' || kindOf(zone) === 'field';

export const num = (v) => (Number.isFinite(v) ? v : null);

/** 盤面のカード（uid で引き、無ければゾーンで引く） */
export function cardAt(board, uid, zone) {
  const byUid = uid ? board?.byUid?.(uid)?.card ?? null : null;
  return byUid ?? (zone ? board?.at?.(zone) ?? null : null);
}

/** 表裏・守備（盤面のカードから。無ければ null） */
export const posOf = (c) => (c ? Object.freeze({ faceUp: Boolean(c.faceUp), defense: Boolean(c.defense) }) : null);

/** 元々の ATK / DEF（core が query した stats の `base_*`） */
export function statBase(stats) {
  return { atk: num(stats?.base_atk ?? stats?.baseAtk), def: num(stats?.base_def ?? stats?.baseDef) };
}

/**
 * **戦闘のカードの今の姿**（`attack` / `battle` の `attacker` / `target` を盤面で膨らませる）。
 * 表裏・守備・ATK / DEF・レベル・元々の値。盤に無ければ payload の値のまま
 */
export function whoOf(who, board) {
  if (!who) return null;
  const card = who.uid ? board?.byUid?.(who.uid)?.card ?? null : null;
  const st = card?.stats ?? null;
  const base = statBase(st);
  return Object.freeze({
    ...who,
    code: card?.code ?? who.code ?? null,
    faceUp: card ? Boolean(card.faceUp) : (who.faceUp ?? true),
    defense: card ? Boolean(card.defense) : Boolean(who.defense),
    atk: num(st?.atk) ?? who.atk ?? null,
    def: num(st?.def) ?? who.def ?? null,
    level: num(st?.level) ?? who.level ?? null,
    baseAtk: base.atk ?? who.baseAtk ?? null,
    baseDef: base.def ?? who.baseDef ?? null,
  });
}

/** 積まれているリンク（このリンクまで。チェーンの番号の順） */
export function linksUpTo(payload) {
  const n = Number(payload?.link?.chain ?? payload?.chain) || 0;
  return Object.freeze((payload?.chainLinks ?? [])
    .filter((l) => l.chain <= n)
    .map((l) => Object.freeze({
      chain: l.chain, code: l.code ?? null, uid: l.uid ?? null, player: l.player === 1 ? 1 : 0, negated: Boolean(l.negated), disabled: Boolean(l.disabled),
    })));
}
